import React from 'react'

import { IconProps, SIconSpan } from '../../../common/styles/Icons'

const FilterIcon = ({
    fill = 'currentColor',
    size = 14,
    title,
    id = 'filter-icon',
    ...props
}: IconProps): React.ReactElement => {
    return (
        <SIconSpan {...props} title={title} id={id} size={size}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 24 24"
                fill="none"
                stroke={fill}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
            </svg>
        </SIconSpan>
    )
}

export default FilterIcon
